import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["search", "tag", "createButton", "newTags"]

  connect() {
    this.filterTimeout = null
    this.filter()
  }

  filter() {
    clearTimeout(this.filterTimeout)
    this.filterTimeout = setTimeout(() => {
      const query = this.searchTarget.value.trim().toLowerCase()
      let matches = 0

      this.tagTargets.forEach((tagEl) => {
        const name = (tagEl.dataset.tagName || "").toLowerCase()
        const isMatch = query === "" || name.includes(query)
        tagEl.classList.toggle("hidden", !isMatch)
        if (isMatch) matches += 1
      })

      this.updateCreateButton(query, matches)
    }, 200)
  }

  updateCreateButton(query, matches) {
    if (!query || matches > 0 || this.isNewTagAlreadyAdded(query)) {
      this.createButtonTarget.classList.add("hidden")
      this.createButtonTarget.textContent = ""
      return
    }

    this.createButtonTarget.textContent = `Create tag "${this.searchTarget.value.trim()}"`
    this.createButtonTarget.classList.remove("hidden")
  }

  createTag() {
    const name = this.searchTarget.value.trim()
    if (!name || this.isNewTagAlreadyAdded(name)) return

    const pill = document.createElement("span")
    pill.className = "inline-flex items-center gap-2 rounded-full border border-ink-muted px-3 py-1"
    pill.dataset.tagName = name.toLowerCase()

    const label = document.createElement("span")
    label.textContent = name

    const removeButton = document.createElement("button")
    removeButton.type = "button"
    removeButton.className = "text-ink-muted hover:text-ink"
    removeButton.textContent = "×"
    removeButton.addEventListener("click", () => {
      pill.remove()
      this.filter()
    })

    const hiddenInput = document.createElement("input")
    hiddenInput.type = "hidden"
    hiddenInput.name = "story[new_tag_names][]"
    hiddenInput.value = name

    pill.append(label, removeButton, hiddenInput)
    this.newTagsTarget.appendChild(pill)

    this.searchTarget.value = ""
    this.filter()
  }

  preventSubmit(event) {
    if (event.key === "Enter") {
      event.preventDefault()
    }
  }

  isNewTagAlreadyAdded(name) {
    const needle = name.toLowerCase()
    return this.newTagsTarget.querySelector(`[data-tag-name="${needle}"]`) !== null
  }
}
